<template>
  <footer class="footer-agir">
    <p class="footer-agir__texto">
      © {{ ano }} <strong>Agir 360</strong>. Todos os direitos reservados.
    </p>
  </footer>
</template>

<script>
export default {
  name: "FooterAgir360",

  computed: {
    ano() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped lang="scss">
.footer-agir {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px 16px;
  padding: 14px 24px;
  border-top: 1px solid #e3e8f2;
  background: #f7f9fd;
  color: #6b6b6b;
  font-size: 0.85rem;
}

.footer-agir__texto {
  margin: 0;
}
</style>
